export default __webpack_public_path__ + "static/bouy-64de7192d52e3c3414961516e302d825.svg";